
<template>
  <section>
    <div class="area_pantalla">
    <div class="scroll_vertical">
    <div style="height: 22%"></div>

      <center>
        <div style="width: 77%; max-width: 400px">
          <img style="width: 80%; max-width: 300px" src="@/assets/logo-rackon2-w-contorno-eq.svg" />

          <div v-if="!final">
            <div class="mt-10 text-h6" style="color: #bead87">Cambiar contraseña</div>

            <v-form v-on:submit.prevent v-model="permitirCambioContrasenia">

              <v-text-field 
                autocomplete="off"
                :type="mostrarPassword ? 'text' : 'password'"
                :append-icon="mostrarPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="mostrarPassword = !mostrarPassword"
                class="mt-7 ma-0"
                ref="password"
                label="Contraseña"
                :rules="[rvValorNoVacio]"
                v-model="contrasenia"
                @keyup.enter="permitirCambioContrasenia && enviarContrasenia()"/>
                
              <v-text-field 
                autocomplete="off"
                :type="mostrarPassword ? 'text' : 'password'"
                :append-icon="mostrarPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="mostrarPassword = !mostrarPassword"
                class="mt-7 ma-0"
                ref="repeat-password"
                label="Repetir Contraseña"
                :rules="[rvValorNoVacio]"
                v-model="contrasenia2"
                @keyup.enter="permitirCambioContrasenia && enviarContrasenia()"/>

              <v-spacer></v-spacer>
              <v-btn 
                ref="entrar" 
                :disabled="(!permitirCambioContrasenia)"
                elevation="2"
                style="mt-20"
                color="pink darken-4"  
                @click="enviarContrasenia()"
              >Cambiar</v-btn>
            </v-form>
          </div>

          <v-container>
            <div class="mt-10 text-h6" :class="postError ? 'red--text' : 'green--text'">
              {{mensaje_cambiar_contrasenia}}
            </div>
          </v-container>            

          <v-spacer></v-spacer>
          <div v-if="(final) && ($global.deviceInfo.platform == 'web')" class="mt-5">
            <router-link to="/" replace>Iniciar sesión</router-link>
          </div>
          
        </div>
      </center>

    <div style="height: 40px"></div>
    </div>
    </div>
  </section>
</template>

<script>
import * as Validadores from '@/validadores.js'
import api from "@/api";


export default {
  name: "CambiarMiContrasena",
  data: () => ({
    mostrarPassword: false,
    postError: null,
    final: null,
    mensaje_cambiar_contrasenia: '',
    contrasenia: "",
    contrasenia2: "",
  }),

  methods: {
    rvValorNoVacio (valor) { return Validadores.esValorNoVacio (valor) || 'Requerido' },

    enviarContrasenia () {
      var error2=200;
      api.cambiarContrasenia(this.contrasenia, this.$route.query.token_seguridad)
      .then ((respuesta) => {
          error2 = respuesta.status;
      })
      .catch(error => {
          console.log('Error (api.cambiarContrasenia): '+error);
          error2 = -1;
      })
      .finally(() => {  
          this.final=1;
          this.mensaje_cambiar_contrasenia = '';
          if (error2!=200) {
            this.postError=true;
            this.mensaje_cambiar_contrasenia = 'Se ha producido un error al guardar la nueva contraseña';
            console.log('Error (api.cambiarContrasenia): '+error2);
          } else  {
            this.postError=false;
            this.mensaje_cambiar_contrasenia = 'La contraseña ha sido cambiada correctamente';
          }
          this.permitirCambioContrasenia = false;
      })
    } 

  },

  computed: {
    permitirCambioContrasenia() { 
      return Validadores.esValorNoVacio(this.contrasenia) && 
             Validadores.esValorNoVacio(this.contrasenia1) &&
             (this.contrasenia===this.contrasenia2);
    }
  }, 

  mounted() {
    if (this.$global.deviceInfo.platform == "web")
      this.$refs.contrasenia.focus();
  }
};
</script>

<style scoped>

</style>